/**
 * SurfaceCard — mirrors aidea.templateengine/src/slides/components/SurfaceCard
 *
 * Variants:
 *   compact   – tighter padding, standard surface bg
 *   elevated  – stronger bg, used for quote/highlight elements
 *   (default) – normal padding, standard surface bg
 */
import React from "react";

/* eslint-disable react/prop-types */

export function SurfaceCard({ children, compact, elevated, style }) {
  return (
    <div
      className={`atomic-surface-card${compact ? " atomic-surface-card--compact" : ""}${elevated ? " atomic-surface-card--elevated" : ""}`}
      style={{
        background: elevated ? "var(--color-bg-surface-strong)" : "var(--color-bg-surface)",
        border: "var(--stroke-thin) solid var(--color-border-subtle)",
        borderRadius: "var(--surface-radius)",
        padding: compact ? "var(--surface-padding-compact)" : "var(--surface-padding)",
        boxSizing: "border-box",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default SurfaceCard;
